import Vue from 'vue';
import ApiUrl from '../apiurl';
import Mock from '../mock/Mock.js';
import { stat } from 'fs';


export default {
    namespaced: true,
    state: {
        // 
        equipCategories: [],
        // 常用搜索词
        commonSearchKeywords: [],
        // 搜索结果
        searchResult: [],
        searchStatus: 0,
        // 保存的搜索方案
        savedEquipSearchSchemas: [], //[{id:'xxx',status:1}]       
        //最后选择的结果集生成key，保存，用于请求数据   
        currentModuleName: '',
        equipOptions: [],
    },
    getters: {
        // 模糊搜索字段
        equipCategories: (state) => {
            return state.equipCategories;
        },
        // 常用搜索词
        commonSearchKeywords: (state) => {
            return state.commonSearchKeywords;
        },
        // 搜索结果
        searchResult: (state) => {
            return state.searchResult;
        },
        equipOptions: (state) => {
            return state.equipOptions;
        },
        // 搜索参数


        // 已选择的结果
        selectionResult: (state) => {
            return state.selectionResult;
        },
        //设置当前模块名
        currentModuleName: (state) => {
            return state.currentModuleName;
        },



        // 保存的搜索方案
        savedEquipSearchSchemas: (state) => {
            return state.savedEquipSearchSchemas;
        },

        // getSavedEquipSearchSchema: (state,id) => {
        //     return state.savedEquipSearchSchemas.find(x=>x.id ==id);
        // },

        searchStatus: (state) => {
            return state.searchStatus;
        },
    },
    mutations: {
        // 搜索结果
        setSearchResult(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'searchResult', [...newValue]);
            }
        },
        setEquipOptions(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'equipOptions', [...newValue]);
            }
        },
        setHasSearchResult(state, newValue) {
            Vue.set(state, 'searchStatus', newValue);
        },

        //设置当前模块名
        setCurrentModuleName(state, newValue) {
            Vue.set(state, 'currentModuleName', newValue);
        },
        // 模糊搜索字段
        setEquipCategories(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'equipCategories', [...newValue]);
            }
        },

        // 常用搜索词
        setCommonSearchKeywords(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'commonSearchKeywords', [...newValue]);
            }
        },




        // 设置保存搜索方案
        setSavedEquipSearchSchemas(state, newValue) {
            if (Array.isArray(newValue)) {
                console.log(newValue);
                Vue.set(state, 'savedEquipSearchSchemas', [...newValue]);
            }
        },



        // 添加/更新保存的搜索方案
        upsertSavedEquipSearchSchemas(state, newValue) {

            if (newValue && newValue.id) {
                let i = state.savedEquipSearchSchemas.findIndex(item => item.id && item.id === newValue.id);
                if (i === -1) {
                    state.savedEquipSearchSchemas.push(newValue);
                } else {
                    Vue.set(state.savedEquipSearchSchemas, i, {...newValue });
                }
            }
        },

        // 清空当前搜索字段
        clearCurrentSearchSchema(state) {
            var newarr = [];
            for (var i = 0; i < state.equipOptions.length; i++) {
                //Vue.set(state, 'equipOptions[i].status', 1);  

                var cur = state.equipOptions[i];
                cur.status = 1;
                newarr.push(cur);
            }
            Vue.set(state, 'equipOptions', newarr);
        },
        setCurrentSearchSchemea(state, cfg) {
            var newarr = [];
            for (var i = 0; i < state.equipOptions.length; i++) {
                var cur = state.equipOptions[i];
                var find = cfg.find(x => x.id == cur.id);
                if (find) {
                    cur.status = find.status;
                } else {
                    cur.status = 1;
                }

                newarr.push(cur);
            }
            Vue.set(state, 'equipOptions', newarr);
        },
    },
    actions: {
        selectEquipSearchSchema({ commit, state, getters }, id) {
            let schema = state.savedEquipSearchSchemas.find(x => x.id == id);
            //  alert(JSON.stringify(schema.json));
            commit('setCurrentSearchSchemea', JSON.parse(schema.json));
        },
        // 搜索装备
        async doSearch({ commit, state, getters, rootState }, params) {
            console.log(rootState);
            var postData = await params;
            //  postData = {include:[7,8,9,10],exclude:[2,3,4,5]}
            console.log("postData= ");
            console.log(postData);
            postData = { "include": [], "exclude": [], "lineParams": { "1001": ["奥迪汽车公司", "潍柴(重庆)汽车有限公司"], "1002": ["奥迪", "斯柯达"], "1003": [] } };
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.carsbyequip, postData);
                if (rsp && rsp.data && rsp.data.success) {
                    //   console.log(rsp.data.result);
                    var has = rsp.data.result.length > 0;
                    // commit('searchStatus', 1);
                    // commit('setSearchResult', rsp.data.result);

                    commit('commonsearch/setHasSearchResult', has, { root: true });
                    commit('commonsearch/setSearchResult', rsp.data.result, { root: true }); //此处是重点
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }


        },


        //获取参数列表
        async queryEquipList({ commit, state, getters }) {

            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.get(ApiUrl.equip.queryequiplist);
                var list = rsp.data.result;
                var opts = [];
                for (var o of list) {
                    // opts.push({"id":o.id,"tag":o.category,"name":o.name,"val":o.val,"status":1 });
                    o.status = 1;
                    opts.push(o);
                }
                // {"id":25,"tag":"科技","name":"触摸式显示屏","val":"触摸式显示屏","status":1 },
                commit('setEquipOptions', opts);

                let tags = new Set();
                for (let d of opts) {
                    tags.add(d.tag);
                }
                commit('setEquipCategories', [...tags]);

            } catch (e) {
                console.error(e);
            } finally {

                commit('stopLoading', null, { root: true });
            }
        },
        //装备搜索方案
        async saveEquipSearchSchema({ commit, state, dispatch }, { schemaId, name, cb }) {
            let json = state.equipOptions.filter(item => { return item.status != 1 }).map(z => { return { 'id': z.id, 'status': z.status } });
            try {
                commit('startLoading', null, { root: true });
                var postData = {
                    type: "equip", // 方案类型 search 搜索条件 | result 结果集
                    name: name,
                    id: schemaId,
                    module: state.currentModuleName,
                    json: json // 当type == result时 传车款id列表
                }

                const rsp = await axios.post(ApiUrl.common.saveschema, postData);
                if (rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);
                    //  commit('setSavedSearchSchema', rsp.data.result);
                    console.log(state);
                    dispatch('loadEquipSearchSchema');
                }
                cb && cb(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async loadEquipSearchSchema({ commit, state }) {
            try {
                const rsp = await axios.post(ApiUrl.common.schemalist, { 'module': state.currentModuleName, type: "equip", simple: false });
                if (rsp && rsp.data && rsp.data.success) {
                    commit('setSavedEquipSearchSchemas', rsp.data.result);
                    // alert(JSON.stringify(rsp.data.result));
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }

        },

    },
}